/* unplugin-vue-components disabled */import { render } from "./EmptyLine.vue.js?vue&type=template&id=34566763!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./EmptyLine.vue?vue&type=template&id=34566763"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__